import type { EstadoJogo } from '@core/motor/estados';
import { complementoDoEstado, mensagemDoEstado } from '@core/motor/mensagens';

/**
 * A linha única de feedback junto ao draft (§7.3).
 *
 * O significado nunca depende só de cor: o texto sozinho já diz o estado, e o
 * ponto colorido é redundante, não informativo.
 */

function tomDaFase(fase: EstadoJogo['fase']): 'neutro' | 'realce' | 'atencao' {
  switch (fase) {
    case 'palavra-valida':
    case 'escolher-ancora':
      return 'realce';
    case 'sem-cruzamento':
      return 'atencao';
    default:
      return 'neutro';
  }
}

export function LinhaFeedback({ estado }: { estado: EstadoJogo }) {
  const mensagem = mensagemDoEstado(estado);
  const complemento = complementoDoEstado(estado);

  return (
    /* O `id` é o alvo do `aria-describedby` do campo (ver `CampoDraft`): a
       mensagem existe uma vez só, visível e na árvore de acessibilidade. */
    <p
      id="feedback-estado"
      className="feedback"
      data-tom={tomDaFase(estado.fase)}
      data-fase={estado.fase}
    >
      <span className="feedback__marca" aria-hidden="true" />
      <span>
        {mensagem}
        {complemento !== undefined && (
          <>
            {' · '}
            {complemento}
          </>
        )}
      </span>
    </p>
  );
}
